import type { MetaFunction } from 'react-router';

import { canonicalTag } from '@jane/bloom/resources/meta/canonicalTag';
import { createMetaVariables } from '@jane/bloom/resources/meta/createMetaVariables';
import { getMetaDescription } from '@jane/bloom/resources/meta/description';
import { getRootLoaderData } from '@jane/bloom/resources/meta/getRootLoaderData';
import { parentMeta } from '@jane/bloom/resources/meta/parentMeta';
import { preloadImage } from '@jane/bloom/resources/meta/preloadImage';
import { getMetaTitle } from '@jane/bloom/resources/meta/title';
import type { loader } from '@jane/bloom/routes/_menu.($storeSlug).featured._index/route';

export const featuredRouteMeta: MetaFunction<typeof loader> = (args) => {
  const { customSEO, menuUrl, metaProps } = getRootLoaderData(args);
  const data = args.loaderData;

  // Match metaProps to available customSEO variables
  const metaVariables = createMetaVariables(metaProps);

  const bannerPreloads = [];
  if (
    data?.communicationBanner?.enabled &&
    data?.communicationBanner?.banner_type === 'image'
  ) {
    bannerPreloads.push(
      preloadImage({
        fetchPriority: 'high',
        sizes: data?.communicationBanner?.sizes,
        src: data?.communicationBanner?.fallbackSrc,
        srcSet: data?.communicationBanner?.srcSet,
      })
    );
  }

  return [
    getMetaTitle(customSEO?.featured, metaVariables),
    getMetaDescription(customSEO?.featured, metaVariables),
    canonicalTag(args.location, menuUrl),
    ...bannerPreloads,
    ...parentMeta(args),
  ];
};
